import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import { useStateContext } from "../../../context/StateContext_US";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeleteIcon from "@mui/icons-material/Delete";
import { HashLink } from "react-router-hash-link";
import ReactGA from "react-ga";
import CurrencyFormat from "react-currency-format";

import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

export default function CheckoutDrawer(props) {
  console.log("props", props);
  const [progress, setProgress] = useState(false);
  const { t, i18n } = useTranslation();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const { basket, getSubtotal, removeItemFromBasket, ChangeQuantityToBasket } =
    useStateContext();

  useEffect(() => {
    const gaTrackingId = "UA-221050560-1"; // enter your Tracking ID
    ReactGA.initialize(gaTrackingId, {
      debug: true,
      titleCase: false,
    });
  }, []);

  const buttonClicked = () => {
    ReactGA.event({
      category: "Cart",
      action: "Add to Cart Clicked",
    });
  };

  const toggleDrawer =
    (anchor, open, action = "") =>
    (event) => {
      buttonClicked();
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      if (open && action === "add") {
        props.addToContextBasket();
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 340,
        px: 2,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false, "")}
      onKeyDown={toggleDrawer(anchor, false, "")}
    >
      <List sx={{ position: "relative" }}>
        <ListItem button>
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary={t("SHOPPING CART")} />
        </ListItem>
        <Divider sx={{ pt: 1 }} />
      </List>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          pt: 1,
          zIndex: 1,
          pb: 3,
        }}
      >
        <Box sx={{ pl: "20px" }}>
          {basket?.map((basketEach, idx) => {
            console.log("basketEach =======", basketEach);
            return (
              <>
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    pt: 1,
                  }}
                >
                  <HashLink to={"/product/" + basketEach.linkTo}>
                    <img src={basketEach.image} width="70" alt="" />
                  </HashLink>
                  &nbsp;&nbsp;
                  <Box
                    sx={{
                      pl: 2,
                      fontSize: "13px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      {basketEach.quantity}x&nbsp;
                      <span className=" ">
                        <HashLink to={"/product/" + basketEach.linkTo}>
                          {t(basketEach.name)}
                        </HashLink>
                      </span>
                    </div>

                    <DeleteIcon
                      sx={{
                        color: "gray",
                        mt: "3px",
                        position: "relative",
                        left: "-5px",
                        cursor: "pointer",
                      }}
                      onClick={() => removeItemFromBasket(basketEach.id)}
                    />
                    {props.productId === basketEach.id &&
                    +props.numOfProduct <
                      +basketEach.quantity + +props.quantityToAdd ? (
                      <Box
                        style={{
                          color: "#153a5a",
                          fontSize: "11px",
                          fontWeight: 600,
                          pt: "5px",
                        }}
                      >
                        {/* You can order only {props.numOfProduct} items. */}
                        현재 주문하실수 있는 최대 갯수는{" "}
                        {props.numOfProduct < 0 ? 0 : props.numOfProduct} 입니다
                      </Box>
                    ) : null}
                  </Box>
                </Box>
              </>
            );
          })}
        </Box>

        <Box sx={{ height: "140px" }}>
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              width: "340px",
              zIndex: 1000,
              backgroundColor: "white",
              height: "140px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Divider sx={{ width: "100%" }} />
            <Box sx={{ pt: 2, width: 1, textAlign: "center" }}>
              {t("Total Price")}:{" "}
              <CurrencyFormat
                decimalScale={2}
                value={getSubtotal()}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />{" "}
            </Box>
            <HashLink to="/cart#top">
              <button className="custom_btn" style={{ marginTop: "20px" }}>
                {t("View Cart")}
              </button>
            </HashLink>
            {/* <HashLink to="/cart">
            <button
              className="custom_btn"
              sx={{
                marginTop: "10px",
              }}
            >
              {t("Checkout")}
            </button>
          </HashLink> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <button
            style={{
              position: "fixed",
              right: 0,
              backgroundColor: "lightgray",
              padding: 10,
              border: 0,
              cursor: "pointer",
              top: "113px",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
            onClick={toggleDrawer(anchor, true, "open")}
          >
            <KeyboardArrowLeftIcon />
          </button>
          {+props.numOfProduct === 0 ? (
            <>
              <button
                className="custom_btn"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  paddingTop: "18px",
                  paddingBottom: "17px",
                  backgroundColor: "#eeeeee",
                  color: "black",
                }}
              >
                Out of Stock
              </button>
            </>
          ) : (
            <>
              <button
                className="custom_btn"
                onClick={toggleDrawer(anchor, true, "add")}
                style={{ width: "155px", height: "50px" }}
              >
                {progress ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress
                      style={{ width: "20px", height: "10px", color: "white" }}
                    />
                  </Box>
                ) : (
                  t("Add to Cart")
                )}
              </button>
              {/* <button>Add</button> */}
            </>
          )}{" "}
          {/* <Box>
            <button>미국 장바구니</button> <button>한국 장바구니</button>
          </Box> */}
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
